module.exports = __webpack_public_path__ + "img/audio-portrait_en.40ff00f.jpg";